var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowAlertFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 16.8125H0.375V0.1875H14.625L11.1813 5.53125L14.625 10.875H1.5625V16.8125Z",
    fill: "#E8C64F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowAlertFlag);
export default __webpack_public_path__ + "static/media/yellow-alert-flag.ee6cabdd3f358f9f7a7936147cff0879.svg";
export { ForwardRef as ReactComponent };